export const APP_VERSION = 'v1.0.0'

export const isHomologacao = (): boolean => {
  return window.location.hostname.includes('homol')
}
